import React from "react";

const UpdateLead = ({ formData, handleChange, handleSubmit, loading, error }) => {
  return (
    <div className="p-6 max-w-lg mx-auto bg-white shadow rounded">
      <h2 className="text-2xl font-bold mb-4">Update Application</h2>

      {/* Display Loading State */}
      {loading && <p className="text-blue-500 mb-4">Updating...</p>}

      {/* Display Error Message */}
      {error && <p className="text-red-500 mb-4">{error}</p>}

      <form onSubmit={handleSubmit}>
        {/* Name */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Name</label>
          <input
            type="text"
            name="name"
            value={formData.name}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter name"
            required
          />
        </div>

        {/* Email */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Email</label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter email"
            required
          />
        </div>

        {/* WhatsApp */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">WhatsApp</label>
          <input
            type="text"
            name="whatsapp"
            value={formData.whatsapp}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter WhatsApp number"
            required
          />
        </div>

        {/* Slug */}
        <div className="mb-4">
          <label className="block text-gray-700 font-medium">Slug</label>
          <input
            type="text"
            name="slug"
            value={formData.slug}
            onChange={handleChange}
            className="border w-full p-2"
            placeholder="Enter slug"
          />
        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="bg-blue-600 text-white px-4 py-2 rounded hover:bg-blue-700"
          disabled={loading}
        >
          {loading ? "Updating..." : "Update Application"}
        </button>
      </form>
    </div>
  );
};

export default UpdateLead;
